/** cSpell:ignore polyfill */
/**
 * project entry point /  main entry.
 * powered by CRA.
 */

// polyfill must be the top of the main entry.
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'html5-history-api';

import { createBrowserHistory } from 'history';

import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { Modal, Result } from 'antd';
// add routes config.
import routes from './config/routes';
// root component wrapper.
import Container from './components/layout/Container';
import I18n from './components/layout/Container/I18n';
import Form from './pages/login/components/Form';
import { network, generators, maths } from './utils';
import Theme from './config/theme';
import eventBus from './components/layout/Container/EventBus';
// add global style.
import './style/global.less';

const history = createBrowserHistory({
  basename: process.env.TARGET || '',
});

const AuthorizeModal = () => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const authBtnShow = document.getElementById('b2b-auth-show');
    const authBtnClose = document.getElementById('b2b-auth-close');
    const showFn = () => {
      setVisible(true);
      // !! 这里用来处理层级问题……因为左侧商品分类菜单的层级，因为业务要调高(比如收藏夹复制的时候有浮窗，层级就比modal高，所以菜单层级也比modal高)
      const authModal = document.querySelector('.auth-modal');
      // 当然，这个问题其实并不会出现，因为能出现这个bug的只有首页，而实际上，首页是不需要权限的，不会有弹窗；但是不保证其他case不会导致首页出弹窗，所以必须要处理
      const mask = authModal.parentElement.querySelector('.ant-modal-mask');
      mask.classList = mask.classList.contains('auth-modal-zIndex')
        ? mask.classList
        : ['ant-modal-mask auth-modal-zIndex'];
    };

    const closeFn = () => {
      setVisible(false);
    };

    authBtnShow.addEventListener('click', showFn, false);
    authBtnClose.addEventListener('click', closeFn, false);

    return () => {
      authBtnShow.removeEventListener('click', showFn, false);
      authBtnClose.removeEventListener('click', closeFn, false);
    };
  }, []);

  return (
    <>
      <div id="b2b-auth-show" />
      <Modal
        forceRender
        className="auth-modal-wrapper"
        wrapClassName="auth-modal"
        title="会员登录"
        width={400}
        maskClosable={false}
        visible={visible}
        footer={null}
        onCancel={() => setVisible(false)}
      >
        <Form mode="modal" history={history} />
      </Modal>
      <div id="b2b-auth-close" />
    </>
  );
};

const MountWithRouter = () => {
  const [layoutKey, setLayoutKey] = React.useState(maths.getSnowFlake());

  React.useEffect(() => {
    /**
     * reload
     */
    eventBus.addListener(eventBus.type.FULL_LAYOUT_RELOAD, () => {
      setLayoutKey(maths.getSnowFlake());
    });
  }, []);

  return (
    <I18n>
      <React.Fragment key={`${layoutKey}`}>
        <Container history={history}>
          <Router history={history}>{renderRoutes(routes)}</Router>
        </Container>
        <AuthorizeModal />
      </React.Fragment>
    </I18n>
  );
};

const preRender = async () => {
  const res = await Promise.all([
    network.get('/sys/queryConfigByConfCode.do', { params: { confCode: 'portalTheme' } }),
    network.get('/sys/queryConfigByConfCode.do', { params: { confCode: 'announcementPosition' } }),
  ]);
  const [themeRes, broadcastRes] = res;
  const themeInstance = new Theme();
  if (themeRes.success) {
    const index = generators.generatorObject(themeRes.data).confValue;
    themeInstance.setScale(index);
    themeInstance.setFixBottom(index);
  }
  if (broadcastRes.success) {
    const index = generators.generatorObject(broadcastRes.data).confValue;
    themeInstance.setBroadcastType(index);
  }
  window.tmConfig = themeInstance;
};

const mountNode = document.getElementById('root');

preRender()
  .then(() => {
    ReactDOM.render(<MountWithRouter />, mountNode);
  })
  .catch((reason) => {
    ReactDOM.render(
      <I18n>
        <Result status="404" />
      </I18n>,
      mountNode,
    );
  });
